import { observer } from 'mobx-react-lite';
import { useLayoutEffect, useState } from 'react';
import { Button, Input, Message, Modal } from 'semantic-ui-react';
import { Activity } from '../../../models/activity';
import { useStore } from '../../../stores/store';
import { userLanguage } from '../../userLanguageSchema/userLanguage';

interface Props {
  activityid: string;
  barcodeValue: string | undefined;
}

function BarCodeScannerModal({ activityid, barcodeValue }: Props) {
  const { dashboardStore, activityStore, commonStore } = useStore();
  const { activityRegistryBarcode } = activityStore;
  const [, setOpen] = useState(false);
  const [code] = useState<string>('');
  const [errorState, setErrorState] = useState('');

  useLayoutEffect(() => {
    let element = document.getElementById('scarBarCode');
    if (element) {
      element.focus();
    }
  }, []);

  const handleSave = () => {
    dashboardStore.setBarCodeValue(code);
    dashboardStore.setOpenBarCodeScanner(false);
  };

  const handleChange = (event: any) => {
    const barcodeData = event.target.value;

    if (barcodeData !== activityid || barcodeData !== barcodeValue) {
      const existData: Activity | undefined =
        activityRegistryBarcode.get(barcodeData);

      if (!existData) {
        setErrorState('');
        // setResult(data);
        dashboardStore.setBarCodeValue(barcodeData);
      }
      if (existData) setErrorState('Data Already Exist');
    } else {
      setErrorState('Same Data Detected');
    }
  };
  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={dashboardStore.dashboard.openBarCodeScanner}
    >
      <Modal.Header
      //Scan Barcode
      >
        {
          (
            userLanguage[0].Level3InventoryRecievingTagScanBarcodeModal
              ?.IRTSBCL01 as any
          )?.[`${commonStore.language.key}`]
        }
      </Modal.Header>
      <Modal.Content>
        <Input
          id={'scarBarCode'}
          placeholder={
            (
              userLanguage[0].Level3InventoryRecievingTagScanBarcodeModal
                ?.IRTSBCTB01 as any
            )?.[`${commonStore.language.key}`]
          } //'Barcode'
          fluid
          name="BarCode"
          onChange={handleChange}
        />

        {errorState.length > 0 && (
          <Message negative>
            <Message.Header>{errorState}</Message.Header>
          </Message>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => dashboardStore.setOpenBarCodeScanner(false)}
          //Cancel
        >
          {
            (
              userLanguage[0].Level3InventoryRecievingTagScanBarcodeModal
                ?.IRTSBCB01 as any
            )?.[`${commonStore.language.key}`]
          }
        </Button>
        <Button
          //content="Save"
          labelPosition="right"
          icon="checkmark"
          onClick={() => handleSave()}
          positive
          disabled={errorState.length > 0 ? true : false}
          content={
            (
              userLanguage[0].Level3InventoryRecievingTagScanBarcodeModal
                ?.IRTSBCB02 as any
            )?.[`${commonStore.language.key}`]
          }
        />
      </Modal.Actions>
    </Modal>
  );
}

export default observer(BarCodeScannerModal);
